module.exports = __webpack_public_path__ + "static/img/project.fd9bad6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project.png
// module id = 2GjR
// module chunks = 1